"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.entities = void 0;
exports.entities = {
  id: 'entities',
  label: 'Entities',
  scopes: ['admin:any'],
  children: [{
    id: 'entity-types',
    label: "Definitions",
    type: 'list-expandable',
    entityTypeName: 'EntityType'
  }, {
    id: 'platform/entities-types',
    label: "Sub Types",
    type: 'list-group',
    entities: ['WorkstreamType', 'BenefitType', 'CitationType', 'ControlType', 'DocumentType', 'EventType', 'FeedEntryType', 'LinkType', 'OfferingType', 'ObjectiveType', 'OrganisationType', 'PageType', 'PostType', 'ProductType', 'ProjectType']
  }]
};